import { useToggle } from '../UNSAFE_useToggle';

export type FocusOptions = {
  isDisabled?: boolean;
};

/**
 * Get status on whether target has focus or not
 * @returns
 */
export function useFocus(settings: FocusOptions = { isDisabled: false }): {
  isFocus: boolean;
  focusProps: Record<string, any>;
} {
  const { bool, setTrue, setFalse } = useToggle(false);
  const focusProps = settings.isDisabled
    ? {}
    : {
        onFocus: setTrue,
        onBlur: setFalse
      };
  return {
    isFocus: settings.isDisabled ? false : bool,
    focusProps: focusProps
  };
}
